"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var Sections = require("sections");
var AccountDetailsTemplate = /** @class */ (function (_super) {
    __extends(AccountDetailsTemplate, _super);
    function AccountDetailsTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.getFavouriteTeam = function () {
            return _this.props.data.customer.tags && _this.props.data.customer.tags.filter(function (tag) { return tag.toLowerCase().includes("afl_team:"); }).length > 0
                ? {
                    handle: _this.props.data.customer.tags
                        .filter(function (tag) { return tag.toLowerCase().includes("afl_team:"); })[0]
                        .slice(9)
                        .toLowerCase()
                        .replace(" ", ""),
                    title: _this.props.data.customer.tags.filter(function (tag) { return tag.toLowerCase().includes("afl_team:"); })[0].slice(9)
                }
                : null;
        };
        _this.toggleAddressForm = function () {
            event.preventDefault();
            _this.state.isAddressFormActive
                ? _this.props.history.push("" + window.location.pathname)
                : _this.props.history.push(window.location.pathname + "#addnewaddress");
            _this.setState({ isAddressFormActive: !_this.state.isAddressFormActive });
        };
        _this.toggleSubscrible = function () { return __awaiter(_this, void 0, void 0, function () {
            var call, marketing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        call = "/apps/toolkit/client/helpers/customer/" + this.props.data.customer.id;
                        marketing = (!this.state.acceptMarketing).toString();
                        return [4 /*yield*/, fetch(call, {
                                method: "post",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    accepts_marketing: marketing
                                })
                            }).then(function (response) { return response.json(); })];
                    case 1:
                        _a.sent();
                        this.setState({ acceptMarketing: !this.state.acceptMarketing });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            isAddressFormActive: false,
            viewWidth: window.outerWidth,
            acceptMarketing: _this.props.data.customer.accepts_marketing
        };
        return _this;
    }
    AccountDetailsTemplate.prototype.render = function () {
        var _this = this;
        var defaults = this.props.data.customer.addresses.find(function (address) { return address.default === true; });
        var detailsLink = {
            url: "/account/logout",
            title: (React.createElement(React.Fragment, null,
                React.createElement(Snippets.Svg, { name: "logout", width: 22, className: "block ml-0-4" }),
                React.createElement("p", { className: "block text-red text-base font-bold ml-0-8 uppercase" }, "logout")))
        };
        var addressLink = {
            title: (React.createElement("div", { className: "py-0-8", onClick: function () { return _this.toggleAddressForm(); } },
                React.createElement("span", null,
                    React.createElement(Snippets.Svg, { name: "plus", height: 16, className: "inline-block align-middle pr-0-4 text-navy-dark" })),
                React.createElement("span", { className: "inline-block align-middle pr-0-2 text-base text-navy-dark font-bold uppercase" }, "Add new address")))
        };
        var orderLink = {
            url: "/account/?view=orders",
            title: (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "block text-navy-dark text-base font-bold ml-0-8 uppercase" }, "View All"),
                React.createElement(Snippets.Svg, { name: "chevron-right", width: 12, className: "block ml-0-4" })))
        };
        var isMobile = !!(this.state.viewWidth < 768);
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.AccountFrame, __assign({}, this.props),
                React.createElement(Snippets.AccountCard, { title: "My Details", link: detailsLink },
                    React.createElement(Snippets.Card, { className: "rounded" },
                        React.createElement("div", { className: "flex flex-wrap" },
                            React.createElement("div", { className: "w-full sm:w-1/2 mb-2 sm:mb-0" }, defaults ? (React.createElement(Snippets.AddressCard, { address: defaults })) : (React.createElement("div", { className: "flex flex-col text-base text-grey-dark" },
                                React.createElement("div", { className: "mb-0-8" },
                                    React.createElement("span", null, this.props.data.customer.first_name),
                                    "\u00A0",
                                    React.createElement("span", null, this.props.data.customer.last_name)),
                                React.createElement("div", null, this.props.data.customer.email)))),
                            React.createElement("div", { className: "w-full sm:w-1/2" },
                                React.createElement("div", { className: "flex flex-col mb-2-4" },
                                    !!this.getFavouriteTeam() && (React.createElement("div", { className: "flex items-center mb-0-6" },
                                        React.createElement(Snippets.Svg, { name: this.getFavouriteTeam().handle, width: 32 }),
                                        React.createElement("span", { className: "text-grey-dark text-sm" }, this.getFavouriteTeam().title))),
                                    React.createElement("span", { className: "block text-grey-dark text-base" }, "You are currently " + (this.state.acceptMarketing ? "" : "not ") + "registered to receive exclusive promotions from the AFL Store")),
                                React.createElement("div", { className: "block" },
                                    React.createElement(Snippets.KeyBenefits, __assign({}, this.props, { title: "Key Benefits", titleStyle: "font-bold text-navy-dark capitalize mb-1-2 text-base", benefitStyle: "flex items-center text-grey-dark mb-1-2 text-base" }))),
                                React.createElement("button", { className: "cursor-pointer border-b border-grey-dark capitalize text-base font-bold mt-1-2", onClick: function (event) { return _this.toggleSubscrible(); } }, this.state.acceptMarketing ? "UNSUBSCRIBE" : "SUBSCRIBE"))))),
                React.createElement(Snippets.AccountCard, { title: "My Addresses", link: addressLink },
                    React.createElement(Snippets.AccountAddresses, __assign({}, this.props, { isAddressFormActive: this.state.isAddressFormActive, toggleAddressForm: this.toggleAddressForm }))),
                React.createElement(Snippets.AccountCard, { title: "Order History", link: orderLink }, this.props.data.customer.orders.length === 0 ? (React.createElement(Snippets.Card, { className: "rounded text-base font-bold text-navy-dark" }, "No order")) : isMobile ? (React.createElement(Snippets.OrderTable, { data: this.props.data.orders, pagination: true, pageSize: 3, preview: false, isMobile: isMobile })) : (React.createElement(Snippets.Card, { className: "rounded" },
                    React.createElement(Snippets.OrderTable, { data: this.props.data.orders, pagination: true, pageSize: 5, preview: false, isMobile: isMobile }))))),
            React.createElement("div", { className: "hidden md:block bg-very-light-pink h-3" }),
            React.createElement(Sections.CTA, __assign({}, this.props, { section: this.props.data.section.cta }))));
    };
    return AccountDetailsTemplate;
}(React.Component));
exports.AccountDetailsTemplate = AccountDetailsTemplate;
